import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { ExternalLink } from "@/components/ExternalLink";

import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type StrategyPermission = {
  id: number;
  user_id: number;
  user_email: string;
  strategy_id: number;
  strategy_name: string;
  company_id?: number;
  company_name?: string;
  level: number;
};

// Function to convert level number to readable string
const getLevelLabel = (level: number): string => {
  const levelMap: Record<number, string> = {
    1: "Owner",
    2: "Cockpit Viewer",
    3: "Approver",
    41: "Listed for Company",
    42: "Listed for Portfolio",
    43: "Listed for User",
    44: "Listed Public",
    45: "Listed Protected",
  };
  return levelMap[level] || `Level ${level}`;
};

// Definition of the columns

export const strategy_permission_columns: ColumnDef<StrategyPermission>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "user_email",
    header: "User",
    cell: ({ row }) => {
      const userId = row.original.user_id;
      const email = row.getValue("user_email");
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/users/${userId}`)}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {email}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "strategy_name",
    header: "Strategy",
    cell: ({ row }) => {
      const strategyId = row.original.strategy_id;
      const name = row.getValue("strategy_name");
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/legacy-quantilia/strategies/${strategyId}`,
          )}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {name}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "company_name",
    header: "Company",
    cell: ({ row }) => {
      const companyId = row.original.company_id;
      const name = row.getValue("company_name");
      if (!companyId || !name) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/companies/${companyId}`)}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {name}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "level",
    header: "Level",
    cell: ({ row }) => {
      const level = row.original.level;
      return getLevelLabel(level);
    },
  },
];
